import {
  GetUserInfo,
  PutUserInfo,
  PostUserInfo,
  SortOrder,
} from '../../services/apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../../services/apiUtils';

const endPoint = 'user';

export interface UserSearchParam {
  userId: string;
  name: string;
  roleId: number;
  companyKey: string;
  order?: SortOrder;
  sortKey?: string;
}

export const getUser = async (
  params: UserSearchParam,
): Promise<GetUserInfo[]> => {
  const queryParams = new URLSearchParams();

  if (params.userId) {
    queryParams.append('userId', params.userId);
  }
  if (params.name) {
    queryParams.append('username', params.name);
  }
  if (params.roleId !== -1) {
    queryParams.append('roleId', params.roleId.toString());
  }
  if (params.companyKey) {
    queryParams.append('companyKey', params.companyKey);
  }
  if (params.sortKey) {
    queryParams.append('sortKey', params.sortKey);
  }
  if (params.order) {
    queryParams.append('order', params.order);
  }

  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};

export const createUser = async (targetUser: PostUserInfo): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'POST',
    body: JSON.stringify(targetUser),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const updateUser = async (targetUser: PutUserInfo): Promise<void> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'PUT',
    body: JSON.stringify(targetUser),
    contentType: 'application/json',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};

export const deleteUser = async (userId: string): Promise<void> => {
  const queryParams = new URLSearchParams();
  queryParams.append('userId', userId);
  const apiUrl = getApiUrl(endPoint);
  const url = `${apiUrl}?${queryParams.toString()}`;
  const header = getHeader({
    method: 'DELETE',
  });

  await fetchWithAuth(url, createHeaderWithCredentials(header));
};
